import React, { Component } from 'react'
import { doListenEvents } from '../../firebase/database/handleEvents'
import { connect } from 'react-redux'
import EventDetails from './CanidateEventDetails'
import moment from 'moment'
import 'moment/locale/de'
import withAuthorization from '../withAuthorization'
import {compose} from 'recompose'
//import authConditionRoleBased from '../UserAuth/authConditionRoleBased'
import {fetchMyApplications} from '../../actions/applications'
import { removeListenerMyApplications } from '../../firebase/database/handleApplications'
import DefaultPage from '../../Container/Layout/DefaultPage'
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import arraySort from 'array-sort'
import CanidateListItems from './CanidateListItems'
import _ from 'lodash'

class CanidateList extends Component {

    constructor(props) {
        super(props);
    
        this.state   = {
          events: null,
          view: null,
          selectedEvent: null,
          filterMyEvents: false,
          anchorEl: null,
          btnName: 'Alle Hilfegesuche'
        };

        this.toggleView = this.toggleView.bind(this)
      }
    
    async componentDidMount(){
        const { onFetchMyApplications, userId } = this.props;
        await doListenEvents('on')
        await onFetchMyApplications(userId)
        moment.locale('de')
    }

    componentWillUnmount() {
        doListenEvents('off')
        removeListenerMyApplications(this.props.userId)
    }

    toggleView = (componentName, event) => {
        const { dispatchEventDetails, toggleHiddenState } = this.props
        if(componentName==='canidateList'){
            dispatchEventDetails(event)
            toggleHiddenState('canidateList', true)
            toggleHiddenState('canidateEventDetails', false)
            this.setState({view: 'EVENT_DETAILS'});
        } else {
            toggleHiddenState('canidateList', false)
            toggleHiddenState('canidateEventDetails', true)
        }
    }

    filterMenueClicked = (e) => {
        this.setState({anchorEl: e.currentTarget})
    }

    closeFilterMenu = (option) => {
        option==='myEvents'
            ? this.setState({filterMyEvents: true, btnName: 'Hilfeangebote'})
            : this.setState({filterMyEvents: false, btnName: 'Alle Hilfegesuche'})
        this.setState({anchorEl: null})
    }
    sortedEvents = events => {
        const eventsArr = _.values(events)
        const sorrtedArr = arraySort(eventsArr, 'data.date')
        return sorrtedArr
    }
    
    render() {
     
        const {events, hidden  } = this.props
        let eventsCounter=0
        // eslint-disable-next-line
        events===null ? null : eventsCounter = _.values(this.props.events).length
        const myEventsCounter = this.props.myApplications.length
        return (
            <DefaultPage headline={{headlineText: 'Hilfebedarf / Meine Hilfeangebote'}}>
                {!hidden && 
                    <FilterMenu 
                        anchorEl={this.state.anchorEl}
                        handleClick={this.filterMenueClicked}
                        handleClose={this.closeFilterMenu}
                        btnName={this.state.btnName}
                        eventsCounter={eventsCounter}
                        myEventsCounter={myEventsCounter}
                    />
                }
                {hidden===true
                        ? <EventDetails doToggleView={this.toggleView} />
                        : <CanidateListItems
                            myApplications={this.props.myApplications}
                            listItems={events===null ? null : this.sortedEvents(events)}
                            doToggleView={this.toggleView}
                            filterMyEvents={this.state.filterMyEvents}
                            />
                }
            </DefaultPage>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    onFetchMyApplications: (userId) => fetchMyApplications(userId),
    dispatchEventDetails: (payload) => dispatch({type: 'FETCH_APPLICATION_DETAILS', payload}),
    toggleHiddenState: (componentName, uiState) =>{
        const payload = {
            component: componentName,
            hidden: uiState
        }
        return dispatch({type: 'TOGGLE_VIEW', payload})}
    });

const mapStateToProps = (state) => ({
    events: state.eventState.eventList,
    userId: state.sessionState.authUser.uid,
    myApplications: state.canidateState.myApplications,
    hidden: state.appState.hiddenState.canidateList
  });


const FilterMenu = props => {
    const {anchorEl, handleClick, handleClose, btnName, eventsCounter, myEventsCounter} = props
    
    return ( 
        <div style={{marginBottom: '1em', textAlign: 'right'}}>
            <span style={{marginRight: '4px'}} >Filter:</span>
            <Button
            aria-owns={anchorEl ? 'simple-menu' : undefined}
            aria-haspopup="true"
            onClick={handleClick}
            variant='outlined'
            size='small'
            style={btnName==='Alle Hilfegesuche' ? {color: '#3f51b5', borderColor:'#3f51b5'} : {color: 'green', borderColor: 'green'}}
            >
                {btnName} {btnName==='Alle Hilfegesuche' ? eventsCounter : myEventsCounter}
            </Button>
            <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            >
            <MenuItem onClick={()=>handleClose('all')}>Alle Hilfegesuche</MenuItem>
            <MenuItem onClick={()=>handleClose('myEvents')}>Meine Hilfeangebote</MenuItem>
            </Menu>
        </div>)
}
const authCondition = (authUser) => !!authUser;
 /*
  const authCondition = (authUser) => {
     return authConditionRoleBased(authUser)
 }
 */

export default compose(
                    withAuthorization(authCondition),
                    connect(mapStateToProps, mapDispatchToProps),
                    //withStyles(styles)
                )(CanidateList)


// WEBPACK FOOTER //
// ./src/Components/Canidates/CanidateList.js